/* eslint-disable */
<template>
<b-form>
  <b-row>
    <b-col lg="4">
      <b-form-group>
        <b-input-group>
          <b-form-input v-model="filter" :placeholder="$t('type_to_search')" />
          <b-input-group-append>
            <b-button variant="danger" :disabled="!filter" @click="filter = ''">{{ $t('clear') }}</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-col>
  </b-row>
  <EasyDataTable
    :headers="statusFields"
    :items="tests"
    :search-value="filter"
    :alternating="true"
    table-class-name="statusTable"
    :rows-per-page="50"
    :hide-rows-per-page="true"
  >
    <template #header-multi="header">
      <b-button size="sm" v-if="hasTeamProfilePermission" class="teamReportButton" @click="openMultiPDFModal()">
        {{ header.text }}
      </b-button>
    </template>
    <template #item-name="item">
      {{getName(item)}}
    </template>
    <template #item-email="item">
      {{getPinOrEmail(item)}}
    </template>
    <template #item-expireDate="item">
      <b-button variant="link" @click="openDateModal(item)" class="endDateButton">
        {{ formatDate(item.expireDate) }}
      </b-button>
    </template>
    <template #item-status="item">
      <span v-if="(!item.startDate && !item.completedDate)">{{ $t('test_not_started') }}</span>
      <span v-if="(item.startDate && !item.completedDate)">{{ $t('test_started') }}</span>
      <span v-if="item.completedDate">{{ $t('test_finished') }}</span>
    </template>
    <template #item-completedDate="item">
      <span v-if="item.completedDate">
        {{ formatDate(item.completedDate) }}
      </span>
    </template>
    <template #item-languageId="item">
      <span :class="'flagItem flag-icon flag-icon-' + getCountryCode(item.languageId)" />
    </template>
    <template #item-pdf="item">
      <b-button size="sm" @click="openPDFModal(item)" v-if="item.completedDate">
        PDF
      </b-button>
    </template>
    <template #item-multi="item">
      <pdf-checkbox v-if="hasTeamProfilePermission" :item="item" :selectedRows="selectedRows" :onSelectedRowsChange="onSelectedRowsChange" />
    </template>
    <template #item-remove="item">
      <div style="float: right;">
        <b-button variant="danger" class="fa fa-trash" @click="$emit('onDeleteTest', item.testId)" />
      </div>
    </template>

    <template #pagination="{ prevPage, nextPage, isFirstPage, isLastPage }">
      <b-button variant="primary" size="sm" class="me-2" :disabled="isFirstPage" @click="prevPage">{{ $t('prevPage') }}</b-button>
      <b-button variant="primary" size="sm" :disabled="isLastPage" @click="nextPage">{{ $t('nextPage') }}</b-button>
    </template>
  </EasyDataTable>

  <b-modal ref="dateModal" v-model="showDateModal" :title="$t('change_end_date')">
    <b-form-input type="date" v-model="expireDateEdited">
    </b-form-input>
    <template #footer>
      <div class="w-100">
        <b-button class="pull-right" variant="danger" @click="cancelExpireDate">{{ $t('cancel') }}</b-button>
        <b-button class="pull-right me-1" variant="primary" @click="setExpireDate">OK</b-button>
      </div>
    </template>
  </b-modal>

  <b-modal v-model="showPDFUnsupportedModal" :title="$t('report_unsupported_testmethod')">
    <p>{{ $t('privatePage.testmethod_unsupported_info') }}</p>
  </b-modal>

  <b-modal ref="pdfModal" v-model="showPDFModal" :title="$t('create_report')">
    <b-row>
      <b-col>
        <h2>{{ $t('participant') }}</h2>
        <p>{{ nameEdited }}</p>
        <h2>{{ $t('test') }}</h2>
        <p>{{ testMethodEdited }}</p>
      </b-col>
      <b-col style="text-align: right;">
        <h2>{{ $t('report_cost') }}</h2>
        <p>{{ pdfRequirements.testIsPaid ? 0 : pdfRequirements.creditCost }} {{ $t('privatePage.credits') }}</p>
        <h2>{{ $t('available_credits') }}</h2>
        <p>{{ userCompany.credits }} {{ $t('privatePage.credits') }}</p>
      </b-col>
    </b-row>
    <hr class="my-4">
    <b-row class="mb-3">
      <b-col>
        <h2>{{ $t('norm_group') }}</h2>
        <b-form-select v-model="selectedNormGroup" :options="optionsNormGroups" value-field="id" text-field="name" />
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col>
        <h2>{{ $t('lang') }}</h2>
        <b-form-select v-model="selectedLanguage" :options="optionsLanguages" value-field="languageId" text-field="langName" />
      </b-col>
    </b-row>
    <b-row v-if="userCompany.hasTestInterpreterPermissions">
      <b-col>
        <b-button class="pull-right" v-bind:disabled="!isValidSelectionForStandardReport" variant="primary" @click="generatePdf">{{ $t('create_report') }}</b-button>
      </b-col>
    </b-row>
    <b-row v-if="hasExpertReports && expertReportDetails" class="common-report-content">
      <b-col>
        <div ref="common-report-front-page">
          <common-report-front-page
            :normGroup="selectedNormGroup"
            :expertReportId="selectedExpertReportId"
            :name="nameEdited"
            :lang="selectedLanguage"
            :optionsNormGroups="optionsNormGroups"
            :optionsExpertReports="optionsExpertReports"
            :testMethod="testMethodEdited"
            :userCompany="userCompany"
            :expertReportDetails="expertReportDetails"
          />
        </div>
      </b-col>
    </b-row>
    <b-row v-if="hasExpertReports" class="mt-3">
      <b-col>
        <h2>{{ $t('expert_report') }}</h2>
        <b-form-select v-model="selectedExpertReportId" :options="optionsExpertReports" value-field="id" text-field="name" @change="onExpertReportChange"/>
        <p>{{this.expertReportMessage}}</p>
        <b-button class="pull-right" v-bind:disabled="!isValidSelectionForExpertReport || loadingExpertReport || loadingReportData" variant="primary" @click="generateExpertReport">
          {{ $t('create_expert_report') }}
          <i v-if="loadingExpertReport" class="fa fa-spinner fa-pulse"></i>
        </b-button>
      </b-col>
    </b-row>
    <template #footer>
      <div class="w-100">
        <b-button class="pull-right" variant="danger" @click="hidePDFModal">{{ $t('cancel') }}</b-button>
      </div>
    </template>
  </b-modal>

    <b-modal v-model="showMultiPDFModal" :title="$t('create_teamprofile')">
      <team-report-modal-content :teamReportValues="teamReportValues" :selectedRows="selectedRows" :pdfRequirements="pdfRequirements" :userCompany="userCompany" :optionsNormGroups="optionsNormGroups" :optionsLanguages="optionsLanguages" :optionsExpertReports="optionsExpertReports" :hasExpertReports="hasExpertReports" :generateTeamReport="generateTeamReport" :generateExpertTeamReport="generateExpertTeamReport"/>
      <template #footer>
        <div class="w-100">
          <b-button class="pull-right" variant="danger" @click="hideMultiPDFModal">{{ $t('cancel') }}</b-button>
        </div>
      </template>
    </b-modal>
  </b-form>
</template>

<script>
import moment from 'moment'
import jsPDF from 'jspdf'
import { mapActions, mapGetters } from 'vuex'
import PdfCheckbox from './PdfCheckbox.vue'
import TeamReportModalContent from './TeamReportModalContent.vue'
import CommonReportFrontPage from '../Reports/CommonReportFrontPage'

export default {
  name: 'status-page',
  data() {
    return {
      selectedNormGroup: null,
      selectedLanguage: null,
      selectedExpertReportId: null,
      filter: '',
      itemEdited: {},
      expireDateEdited: '',
      nameEdited: '',
      testMethodEdited: '',
      showPDFModal: false,
      showMultiPDFModal: false,
      showPDFUnsupportedModal: false,
      showDateModal: false,
      selectedRows: [],
      loadingExpertReport: false,
      loadingReportData: false,
      teamReportValues: {
        selectedNormGroup: null,
        selectedLanguage: null,
        selectedExpertReportId: null,
        teamName: null
      },
      expertReportDetails: null
    }
  },
  props: {
    tests: {},
    pdfRequirements: {},
    currentUser: {}
  },
  components: {
    PdfCheckbox,
    TeamReportModalContent,
    CommonReportFrontPage
  },
  computed: {
    ...mapGetters(['languages']),
    ...mapGetters('userGroupsModule', ['userCompany']),

    statusFields() {
      var fields = [
        {
          value: 'name',
          text: this.$t('name'),
          sortable: true
        },
        {
          value: 'email',
          text: this.$t('email_pin'),
          sortable: true
        },
        {
          value: 'customerTagName',
          text: this.$t('customer_tag'),
          sortable: true
        },
        {
          value: 'testMethodName',
          text: this.$t('method'),
          sortable: true
        },
        {
          value: 'languageId',
          text: ' '
        },
        {
          value: 'expireDate',
          text: this.$t('end_date'),
          sortable: true
        },
        {
          value: 'status',
          text: 'Status'
        },
        {
          value: 'completedDate',
          text: this.$t('finished_date'),
          sortable: true
        },
        {
          value: 'pdf',
          text: ' '
        },
        {
          value: 'multi',
          text: this.$t('team_report')
        },
        {
          value: 'remove',
          text: ' '
        }
      ]
      return fields
    },
    optionsLanguages() {
      var optionLangs = [
        { languageId: null, langName: this.$t('select_a_language') }
      ]

      if (this.languages && this.languages.constructor === Array) {
        for (let i = 0; i < this.languages.length; i++) {
          optionLangs.push(this.languages[i])
        }
      }
      return optionLangs
    },
    optionsNormGroups() {
      var normGroups = [{ id: null, name: this.$t('select_a_normgroup') }]

      if (this.pdfRequirements && this.pdfRequirements.normGroups) {
        normGroups = normGroups.concat(this.pdfRequirements.normGroups)
      }
      return normGroups
    },
    optionsExpertReports() {
      var expertReports = [
        { id: null, name: this.$t('select_a_report'), description: this.$t('select_a_report') }
      ]

      if (this.pdfRequirements && this.pdfRequirements.expertReportOptions) {
        if (this.showMultiPDFModal) {
          const options = this.pdfRequirements.expertReportOptions
            .filter((option) => option.name !== 'TeamProfile')
            .map(filteredOption => {
              return { ...filteredOption, description: this.$t(`privatePage.expert_report_type_${filteredOption.name}`) }
            })
          expertReports = expertReports.concat(options)
        } else {
          expertReports = expertReports.concat(this.pdfRequirements.expertReportOptions)
        }
      }

      return expertReports
    },
    hasExpertReports() {
      if (
        this.pdfRequirements &&
        this.pdfRequirements.expertReportOptions &&
        this.pdfRequirements.expertReportOptions.constructor === Array &&
        this.pdfRequirements.expertReportOptions.length > 0
      ) {
        return true
      } else {
        return false
      }
    },
    isValidSelectionForStandardReport() {
      return !!this.selectedNormGroup && !!this.selectedLanguage
    },
    selectedExpertReport() {
      if (this.hasExpertReports) {
        return this.pdfRequirements.expertReportOptions.filter(
          repOpt => repOpt.id === this.selectedExpertReportId
        )[0]
      }
    },
    isValidSelectionForExpertReport() {
      let isValid = false

      if (
        this.isValidSelectionForStandardReport &&
        this.hasExpertReports &&
        this.selectedExpertReport &&
        this.selectedExpertReport.languages &&
        this.selectedExpertReport.languages.constructor === Array &&
        this.selectedExpertReport.languages.filter(
          lang => lang === this.selectedLanguage
        ).length === 1
      ) {
        isValid = true
      }

      return isValid
    },
    expertReportExtraCreditCost() {
      if (this.isValidSelectionForExpertReport) {
        return this.selectedExpertReport.extraCreditCost
      }
    },
    expertReportMessage() {
      if (
        this.selectedExpertReport &&
        this.userCompany.hasTestInterpreterPermissions
      ) {
        if (this.isValidSelectionForExpertReport) {
          if (!this.selectedExpertReport.isPaid) {
            return this.$t('privatePage.expert_report_cost', { credits: this.expertReportExtraCreditCost })
          }
        } else if (this.selectedNormGroup === null) {
          return this.$t('privatePage.expert_report_please_select', { selection: this.$t('norm_group') })
        } else if (this.selectedLanguage === null) {
          return this.$t('privatePage.expert_report_please_select', { selection: this.$t('lang') })
        } else {
          return this.$t('privatePage.expert_report_invalid_selection')
        }
      }
    },
    hasTeamProfilePermission() {
      const user = this.currentUser
      const permissions = user && user.permissions
      return !!(permissions && permissions.indexOf('TeamReports') !== -1)
    }
  },
  methods: {
    ...mapActions('expertReportsModule', ['getReportDetails']),

    onSelectedRowsChange: function(newRows) {
      this.selectedRows = newRows
    },
    onExpertReportChange: async function(v) {
      try {
        this.loadingReportData = true
        const result = await this.getReportDetails({ reportId: v || '' })
        this.expertReportDetails = result
      } finally {
        this.loadingReportData = false
      }
    },
    openDateModal: function(item) {
      this.itemEdited = item
      this.expireDateEdited = new Date(item.expireDate).toLocaleDateString(
        'sv-SE'
      )
      this.showDateModal = true
    },
    cancelExpireDate: function() {
      this.itemEdited = {}
      this.showDateModal = false
    },
    setExpireDate: function() {
      this.itemEdited.expireDate = this.expireDateEdited
      this.showDateModal = false
      this.$emit('onUpdateTestSuiteExpireDate', this.itemEdited)
      this.itemEdited = {}
    },
    formatDate: function(value) {
      return moment(value).format('YYYY-MM-DD')
    },
    openPDFModal: function(item) {
      this.itemEdited = item
      this.selectedNormGroup = null
      this.selectedLanguage = null
      this.selectedExpertReportId = null
      this.nameEdited = `${item.firstName} ${item.lastName}`
      this.testMethodEdited = item.testMethodName
      this.$emit('onGetPdfRequirements', item)
      this.showPDFModal = true
    },
    openMultiPDFModal: function() {
      const selectedRows = [...this.selectedRows]
      if (!selectedRows || selectedRows.length === 0) return

      // Handle unsupported testmethods for teamreports
      let item = selectedRows[0]
      if (item.testMethodName !== 'LSI II') {
        this.showPDFUnsupportedModal = true
      } else {
        this.teamReportValues = {
          selectedNormGroup: null,
          selectedLanguage: null,
          selectedExpertReportId: null,
          teamName: null
        }
        const testIds = selectedRows.map(i => i.testId)
        this.$emit('onGetPdfRequirementsTeamProfile', testIds)
        this.showMultiPDFModal = true
      }
    },
    hidePDFModal: function() {
      this.itemEdited = {}
      this.$emit('onResetPdfRequirements')
      // this.pdfRequirements = {}
      this.showPDFModal = false
      this.expertReportDetails = null
    },
    hideMultiPDFModal: function() {
      this.itemEdited = {}
      this.$emit('onResetPdfRequirements')
      this.showMultiPDFModal = false
    },
    generatePdf: async function() {
      this.$emit('onGeneratePdf', {
        testId: this.itemEdited.testId,
        normGroupId: this.selectedNormGroup,
        languageId: this.selectedLanguage
      })
      this.hidePDFModal()
    },
    generateTeamReport: function() {
      if (this.selectedRows.length > 0) {
        const maxNrOfTests = 6
        let testIds = []
        this.selectedRows.forEach(({testId}, index) => {
          if (index < maxNrOfTests) {
            testIds.push(testId)
          }
        })
        this.$emit('onGenerateMultiPdf', {
          normGroupId: this.teamReportValues.selectedNormGroup,
          languageId: this.teamReportValues.selectedLanguage,
          tests: testIds
        })
      }
      this.hideMultiPDFModal()
    },
    onGenerateExpertReportComplete: function(hide) {
      this.loadingExpertReport = false
      if (hide) {
        this.hidePDFModal()
      }
    },
    generateExpertReport: async function() {
      this.loadingExpertReport = true

      /* eslint-disable new-cap */
      const doc = new jsPDF('p', 'pt', 'a4', true)
      const addFooter = () => {
        const date = new Date()
        const currentYear = date.getFullYear()
        doc.setFontSize(7)
        doc.text(this.$t('pdfReport.copyright', { year: currentYear }), 30, 810)
      }
      const frontPage = this.$refs['common-report-front-page']
      await doc.html(frontPage)
      addFooter()
      const frontpageBuffer = doc.output('arraybuffer')

      // When done, calls onComplete
      this.$emit('onGenerateExpertReport', {
        testId: this.itemEdited.testId,
        normGroupId: this.selectedNormGroup,
        languageId: this.selectedLanguage,
        reportId: this.selectedExpertReportId,
        frontPage: frontpageBuffer,
        onComplete: this.onGenerateExpertReportComplete
      })
    },
    generateExpertTeamReport: function() {
      let tempTests = this.selectedRows.map(({testId}) => testId)
      this.$emit('onGenerateExpertTeamReport', {
        normGroupId: this.teamReportValues.selectedNormGroup,
        languageId: this.teamReportValues.selectedLanguage,
        reportId: this.teamReportValues.selectedExpertReportId,
        tests: tempTests
      })
      this.hideMultiPDFModal()
    },
    getCountryCode: function(languageId) {
      let langs = this.languages.filter(l => l.languageId === languageId)

      if (langs.length > 0) {
        return langs[0].countryCode
      }

      return ''
    },
    getName: function(item) {
      let name = item.firstName.trim()

      if (name.length > 0) {
        name += ' '
      }

      name += item.lastName.trim()

      return name
    },
    getPinOrEmail: function(item) {
      return item.pin.trim() + item.email.trim()
    }
  }
}
</script>

<style scoped>
.endDateButton {
  padding: 0px;
}
.common-report-content {
  opacity: 0;
  height: 0;
  pointer-events: none;
}
.fa-spinner {
  margin-left: 5px;
  color: #ffffff;
}
.teamReportButton {
  display: block;
  margin: 0 auto;
}
.custom-select {
  margin-bottom: 15px;
}
.my-4 {
  margin-top: 0px !important;
}
</style>
